<header id="page-topbar">
  <div class="navbar-header">
    <div class="d-flex">
      <!-- LOGO -->
      <div class="navbar-brand-box">
        <a href="/" class="logo logo-dark">
          <span class="logo-sm">
            <img src="assets/images/logo.svg" alt="" height="22" />
          </span>
          <span class="logo-lg">
            <img src="assets/images/logo-dark.png" alt="" height="17" />
          </span>
        </a>

        <a href="/" class="logo logo-light">
          <span class="logo-sm">
            <!-- <img src="assets/images/logo-light.svg" alt="" height="22" /> -->
            C
          </span>
          <span class="logo-lg">
            <!-- <img src="assets/images/logo-light.png" alt="" height="19" /> -->
            Cuality
          </span>
        </a>
      </div>

      <button type="button" class="btn btn-sm px-3 font-size-16 header-item" id="vertical-menu-btn" (click)="toggleMobileMenu($event)">
        <i class="fa fa-fw fa-bars"></i>
      </button>
    </div>

    <div class="d-flex">
      <div class="dropdown d-inline-block">
        <button type="button" class="btn header-item" id="page-header-user-dropdown" (click)="logout()">
          <b>Log Out&nbsp;&nbsp;<i class="dripicons-exit"></i> </b>
        </button>
      </div>
    </div>
  </div>
</header>
